import analysisModule from "./analysisModule"

analysisModule.config(["$stateProvider", ($stateProvider) => {
    $stateProvider.state("r2.analysis", {
        data: {
            pageTitle: "{{'title.r2.analysis' | translate}}",
            group: "group.r2.programming.analysis"
        },
        url: "/programming/analysis?routingSessionIdentifier",
        template: "<nlg-analysis-view></nlg-analysis-view>",
        onEnter: ["$stateParams", "supplyService", function ($stateParams, supplyService) {
            supplyService.restrictSession($stateParams.routingSessionIdentifier)
        }]
    })
}])
